import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';

export const templateMaintenanceWindowRebootOptions = document.createElement('template');

templateMaintenanceWindowRebootOptions.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div>

    <gz-title class="title" fontweight="500" fontsize="18" id="reboot-preferences-title"></gz-title>
    <div class="reboot-preferences-notice-subsection mb-3">
      <gz-text fontweight="300" fontsize="14" id="reboot-preferences-notice"></gz-text>
      <gz-title id="reboot-preferences-notice-text" fontsize="12" class="pt-1 info-text"></gz-title>
    </div>

    <gz-form-field id="reboot-preferences-radio-options-form-field">
        <gz-radio-group gz-form-input>
          <gz-radio id="reboot-preferences-radio-options-first"></gz-radio>
          <gz-radio id="reboot-preferences-radio-options-second"></gz-radio>
          <gz-radio id="reboot-preferences-radio-options-third"></gz-radio>
        </gz-radio-group>
        <gz-input-error></gz-input-error>
    </gz-form-field>

    <div id="reboot-between" class="hidden">

       <gz-labeled-content hasFormLabelWidth id="reboot-between-labeled-content">
         <div class="flex-group">
            <gz-form-field id="between-start-form-field"  required>
                <gz-time-picker gz-form-input></gz-time-picker>
                <gz-input-error></gz-input-error>
            </gz-form-field>
            <gz-title fontSize="12" fontWeight="300"></gz-title> <!-- and -->
            <gz-form-field id="between-end-form-field"  required>
                <gz-time-picker gz-form-input></gz-time-picker>
                <gz-input-error></gz-input-error>
            </gz-form-field>
         </div>
      </gz-labeled-content>

      <gz-form-field id="reboot-between-minutes-form-field" class="label-mw-250" required>
        <div class="flex-group">
            <gz-text fontSize="12" fontWeight="300" class="form-description" id="post-description"></gz-text>
            <gz-dropdown labelwidth="80" gz-form-input type='dropdown' class="minutes-dropdown"></gz-dropdown>
            <gz-text fontSize="12" fontWeight="300" class="form-description" id="after-description"></gz-text>
            <gz-input-error></gz-input-error>
        </div>
      </gz-form-field>
      <gz-form-field id='reboot-between-custom-message-form-field' class='label-mw-250'>
        <gz-text fontSize="12" fontWeight="300" class="form-description"></gz-text>
        <gz-textarea gz-form-input></gz-textarea>
        <gz-input-error></gz-input-error>
      </gz-form-field>

    </div>

    <div id="reboot-after" class="hidden">
      <gz-form-field id="reboot-after-minutes-form-field" class="label-mw-250" required>
        <div class="flex-group">
            <gz-dropdown gz-form-input type='dropdown'></gz-dropdown>
            <gz-text fontSize="12" fontWeight="300"></gz-text>
            <gz-input-error></gz-input-error>
        </div>
      </gz-form-field>
      <gz-form-field id='reboot-after-custom-message-form-field' class='label-mw-250'>
         <gz-text fontSize="12" fontWeight="300"></gz-text>
         <gz-textarea gz-form-input></gz-textarea>
         <gz-input-error></gz-input-error>
      </gz-form-field>
    </div>
  </div>
`;
